// initial state
import axios from "axios";
import {getField, updateField} from 'vuex-map-fields';

let baseURL = 'https://admin.hoptone.com/api/';
const debug = process.env.NODE_ENV !== 'production';

if (debug) {
    baseURL = 'http://hoptone.test/api/'
} else {
    baseURL = 'https://admin.hoptone.com/api/'
}
const getDefaultState = () => {
    return {
        currency: 'USD',
        currencyLoaded: false,
        cID: null,
        timezone: null,
        accountcode: null,
        billingCompany: null,
        language: 'EN',
        enabled: true,
        status: '',
        permissions: [],
        role: '',
        user: {
            first_name: null,
            last_name: null,
            company: null,
            phone: null,
            email: null,
            address: null,
            city: null,
            postal_code: null,
            country: null,
        },
        billing: {
            first_name: null,
            last_name: null,
            company: null,
            company_number: null,
            phone: null,
            email: null,
            address: null,
            city: null,
            postal_code: null,
            country: null,
        },
        creditcard: {
            number: null,
            cvc: null,
            month: null,
            year: null,
            first_name: null,
            last_name: null,
        },
        mollie: {
            id: null,
            hasValidMandate: false,

        }
    }
}

const state = {
    currency: 'USD',
    currencyLoaded: false,
    cID: null,
    timezone: null,
    accountcode: null,
    billingCompany: null,
    language: 'EN',
    enabled: true,
    status: '',
    permissions: [],
    role: '',
    user: {
        first_name: null,
        last_name: null,
        company: null,
        phone: null,
        email: null,
        address: null,
        city: null,
        postal_code: null,
        country: null,
    },
    billing: {
        first_name: null,
        last_name: null,
        company: null,
        company_number: null,
        phone: null,
        email: null,
        address: null,
        city: null,
        postal_code: null,
        country: null,
    },
    creditcard: {
        number: null,
        cvc: null,
        month: null,
        year: null,
        first_name: null,
        last_name: null,
    },
    mollie: {
        id: null,
        hasValidMandate: false,
    }
};

// getters
const getters = {
    needUpdate: (state) => {
        if (state.status === 'LOADING') {
            return false;
        }
        if (state.updateRequired) {
            return true;
        }
        return !(state.status === 'SUCCESS' && state.customer.cID != null);
    },
    currency(state) {
        return state.currency;
    },
    name(state) {
        if (state.user.company) {
            return state.user.company;
        }

        return state.user.first_name + ' ' + state.user.last_name;
    },
    email(state) {
        return state.user.email;
    },
    timezone(state) {
        return state.timezone;
    },
    hasCreditcard(state) {
        return state.creditcard.number != null;
    },
    hasValidMandate(state) {
        if (state.mollie) {
            return state.mollie.hasValidMandate;
        }
        return false;
    },
    permissions(state) {
        return state.permissions;
    },
    getField,
};

// actions
const actions = {
    resetState({commit}) {
        commit('resetState')
    },
    getPermissions: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            resolve(state.permissions)
        })
    },
    loadCurrency: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            if (state.currencyLoaded) {
                resolve(state.currency);
                return;
            }

            axios({
                url: baseURL + 'customer/currency', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    commit('SET_CUSTOMER_CURRENCY', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    loadUser: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit('USER_REQUEST');
            axios({
                url: baseURL + 'customer', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    commit('USER_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_ERROR', err);
                    reject(err)
                })
        })
    },
    loadMollie: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit('USER_REQUEST');
            axios({
                url: baseURL + 'customer/mollie', method: 'GET', headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            })
                .then(resp => {
                    commit('MOLLIE_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('USER_ERROR', err);
                    reject(err)
                })
        })
    },
    saveUser: ({commit, dispatch}) => {
        return axios({
            url: baseURL + 'customer', method: 'POST', headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }, data: {
                user: state.user
            },
        }).then(resp => {
            commit('USER_SUCCESS', resp.data.data);
        }).catch(err => {
            commit('USER_ERROR', err);
            return Promise.reject(err);
        })
    },
    saveBilling: ({commit, dispatch}) => {
        return axios({
            url: baseURL + 'customer/billing', method: 'POST', headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }, data: {
                billing: state.billing
            },
        }).then(resp => {
            commit('USER_SUCCESS', resp.data.data);
        }).catch(err => {
            commit('USER_ERROR', err);
            return Promise.reject(err);
        })
    },
    saveCreditcard: ({commit, dispatch}) => {
        return axios({
            url: baseURL + 'customer/creditcard', method: 'POST', headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }, data: {
                creditcard: state.creditcard
            },
        }).then(resp => {
            commit('USER_SUCCESS', resp.data.data);
        }).catch(err => {
            commit('USER_ERROR', err);
            return Promise.reject(err);
        })
    },
    deleteCreditCard: ({commit, dispatch}) => {
        return axios({
            url: baseURL + 'customer/creditcard', method: 'DELETE', headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }
        }).then(resp => {
            commit('USER_SUCCESS', resp.data.data);
        }).catch(err => {
            commit('USER_ERROR', err);
            return Promise.reject(err);
        })
    },
    connectMollie: ({commit, dispatch}, url) => {
        return axios({
            url: baseURL + 'customer/billing/mollie', method: 'POST', headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            },
            data: {
                redirectUrl: url.url,
            }
        }).then(resp => {
            return Promise.resolve(resp.data);
        }).catch(err => {
            commit('USER_ERROR', err);
            return Promise.reject(err);
        })
    },
};

// mutations
const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    SET_CUSTOMER_CURRENCY: (state, currency) => {
        state.currency = currency;
        state.currencyLoaded = true;
    },
    SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions;
    },
    USER_REQUEST: (state) => {
        state.status = 'loading'
    },
    USER_SUCCESS: (state, user) => {
        state.status = 'success';
        state.cID = user.cID;
        state.user = user.user;
        state.timezone = user.timezone;
        state.billing = user.billing;
        state.creditcard = user.creditcard;
        state.mollie = user.mollie;
        state.permissions = user.permissions;
        sessionStorage.setItem('permissions', user.permissions);

        state.role = user.role;
    },
    MOLLIE_SUCCESS: (state, user) => {
        state.status = 'success';
        state.mollie = user;
    },
    USER_ERROR: (state, error) => {
        state.status = 'error'
    },
    updateField,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
